import React from "react"

import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

// parse the PVI data to the appropriate format
// some examples:
// -3.1 ==> R+3
// 4.7 ==> D+5
// 0.1 => D+0
const parsePVI = (number) => {
    try {
        const parsedNumber = parseFloat(number)
        if (number > 0) {
            return `D+${Math.round(parsedNumber)}`
        } else if (number === 0) {
            return `EVEN`
        } else if (number < 0) {
            return `R+${Math.abs(Math.round(parsedNumber))}`
        } else {
            return ``
        }
    } catch (e) {
        return ""
    }
}

export const CookPVICell = ({ children, ...props }) => <CellWrapper {...props}>{parsePVI(children)}</CellWrapper>
